import _createClass from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { backend_util } from '@tensorflow/tfjs-core';
export var ConcatProgram = /*#__PURE__*/_createClass(
// Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
function ConcatProgram(shapes) {
  _classCallCheck(this, ConcatProgram);
  this.outputShape = [];
  this.outputShape = backend_util.computeOutShape(shapes, 1 /* axis */);
  this.variableNames = shapes.map(function (_, i) {
    return "T".concat(i);
  });
  var offsets = new Array(shapes.length - 1);
  offsets[0] = shapes[0][1];
  for (var i = 1; i < offsets.length; i++) {
    offsets[i] = offsets[i - 1] + shapes[i][1];
  }
  var snippets = ["if (yC < ".concat(offsets[0], ") setOutput(getT0(yR, yC));")];
  for (var _i = 1; _i < offsets.length; _i++) {
    var shift = offsets[_i - 1];
    snippets.push("else if (yC < ".concat(offsets[_i], ") ") + "setOutput(getT".concat(_i, "(yR, yC-").concat(shift, "));"));
  }
  var lastIndex = offsets.length;
  var lastShift = offsets[offsets.length - 1];
  snippets.push("else setOutput(getT".concat(lastIndex, "(yR, yC-").concat(lastShift, "));"));
  this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        ".concat(snippets.join('\n        '), "\n      }\n    ");
});